var $d9ab5c2611e0bcd3$exports = {};
$d9ab5c2611e0bcd3$exports = {
  "alpha": "Alfa",
  "black": "czarny",
  "blue": "Niebieski",
  "blue purple": "niebiesko-fioletowy",
  "brightness": "Jasno\u015B\u0107",
  "brown": "br\u0105zowy",
  "brown yellow": "br\u0105zowo-\u017C\xF3\u0142ty",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "cyjanowy",
  "cyan blue": "cyjanowo-niebieski",
  "dark": "ciemny",
  "gray": "szary",
  "grayish": "szarawy",
  "green": "Zielony",
  "green cyan": "zielono-cyjanowy",
  "hue": "Odcie\u0144",
  "light": "jasny",
  "lightness": "Jaskrawo\u015B\u0107",
  "magenta": "purpurowy",
  "magenta pink": "purpurowo-r\xF3\u017Cowy",
  "orange": "pomara\u0144czowy",
  "orange yellow": "pomara\u0144czowo-\u017C\xF3\u0142ty",
  "pale": "blady",
  "pink": "r\xF3\u017Cowy",
  "pink red": "r\xF3\u017Cowo-czerwony",
  "purple": "fioletowy",
  "purple magenta": "fioletowo-purpurowy",
  "red": "Czerwony",
  "red orange": "czerwono-pomara\u0144czowy",
  "saturation": "Nasycenie",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " przezroczysto\u015Bci");
  },
  "very dark": "bardzo ciemny",
  "very light": "bardzo jasny",
  "vibrant": "intensywny",
  "white": "bia\u0142y",
  "yellow": "\u017C\xF3\u0142ty",
  "yellow green": "\u017C\xF3\u0142to-zielony"
};
export { $d9ab5c2611e0bcd3$exports as default };